import React from 'react'

const CodeDescription = ({ primary = 'Request Content-Types:', secondary = '' }) => (
  <p className="mx-6 my-2 text-gray-300">
    {primary} {!!secondary && <span className="ml-2 text-gray-600">{secondary}</span>}
  </p>
)

export default CodeDescription
